import { useState } from 'react'
import { CText } from './CText'
import { Col, Row } from 'antd'
import CInput from './Input'
import MobileDatePicker from './MobileDatePicker'
import CustomButton from './CustomButton'
import { buttonTypes } from '../shared-constants/buttonTypes'
import { icons } from '../shared-asstes/icons'
import styled from 'styled-components'
import ContentLayout from './ContentLayout'
import useUpgradeLevelModal from '../shared-hooks/useUpgradeLevelModal'
import { fontsWeight } from '../shared-constants/fonts'
import { DEVICE } from '../shared-constants/breakPoints'

export const UpgradeUserLevel = ({
  submitUpgradeUserLevelForm,
  loading,
  showLaterBtn = true,
}) => {
  const { closeUpgradeUserModal } = useUpgradeLevelModal()
  const [birthDate, setBirthDate] = useState('')
  const [nationalCode, setNationalCode] = useState('')

  const onChangeBirthDay = (value) => {
    setBirthDate(value)
  }

  const onChangeNationalCode = (value) => {
    setNationalCode(value)
  }

  const sendUpgradeLevel = () => {
    submitUpgradeUserLevelForm(nationalCode, birthDate).then(() => {
      closeUpgradeUserModal()
    })
  }

  return (
    <ContentLayout paddingTop={false}>
      <Row>
        <Col span={24}>
          <CText className='mb-2'>
            جهت استفاده از تمامی{' '}
            <CText tag='span' fontWeight={fontsWeight.BOLD}>
              امکانات شهرزاد
            </CText>
            ، لطفاً با تکمیل اطلاعات زیر، سطح کاربری خود را ارتقاء دهید.
          </CText>
        </Col>

        <Col span={24}>
          <CInput
            infoText={
              'کد ملی وارد شده باید با نام دارنده شماره موبایل مطابقت داشته باشد!'
            }
            onChange={onChangeNationalCode}
            label={'کدملی'}
          />
        </Col>

        <Col span={24}>
          <MobileDatePicker
            hasDefaultValue={false}
            customIcon={icons.CALENDAR_GRAY}
            onChange={onChangeBirthDay}
            placeHolder='تاریخ تولد'
          />
        </Col>
      </Row>
      <ButtonBox>
        <Col span={24}>
          <CustomButton
            loading={loading}
            className={'my-2'}
            width={'100%'}
            onClick={sendUpgradeLevel}
            styletype={buttonTypes.PRIMARY_FILL}
          >
            {'ارتقا سطح کاربری'}
          </CustomButton>
          {showLaterBtn && (
            <CustomButton
              width={'100%'}
              styletype={buttonTypes.NO_STYLE}
              onClick={closeUpgradeUserModal}
            >
              {'بعدا انجام میدهم'}
            </CustomButton>
          )}
        </Col>
      </ButtonBox>
    </ContentLayout>
  )
}

const ButtonBox = styled(Row)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100px;
  width: 80%;
  margin: auto;

  @media ${DEVICE.laptop} {
  }
`
